import React, { FC } from 'react'
import cn from '../../lib/utils/cn'
import RadioButton from './RadioButton'

export interface RadioButtonOption {
	label: string
	value: string | number
	disabled?: boolean
}

interface RadioGroupProps {
	options: RadioButtonOption[]
	value: string | number
	onChange: (value: string | number) => void
	className?: string
	radioClassName?: string
	radioLabelClassName?: string
}

const RadioGroup: FC<RadioGroupProps> = ({
	options,
	value,
	onChange,
	className,
	radioClassName,
	radioLabelClassName,
}) => {
	return (
		<div className={cn('flex flex-col gap-2', className)}>
			{options.map((option) => (
				<RadioButton
					key={option?.value}
					label={option?.label}
					value={option?.value}
					checked={value === option?.value}
					onChange={onChange}
					disabled={Boolean(option?.disabled)}
					className={radioClassName}
					labelClassName={radioLabelClassName}
				/>
			))}
		</div>
	)
}

export default RadioGroup
